export const i18n = {
  errors: {
    required: 'Zorunlu Alan',
    fullName: 'Ad ve Soyad arasında boşluk olmalıdır',
    fullNameNumeric: 'Ad soyad alanı numara içermemelidir',
    email: 'Geçerli Email Giriniz!',
    tcMin: 'Tc No 11 karakter olmalıdır',
    tcMax: 'Tc No 11 karakter olmalıdır',
    vergMin: 'Vergi Numarası 10 karakter olmalıdır',
    vergMax: 'Vergi Numarası 10 karakter olmalıdır',
    password: 'Parola kurallara uygun değil',
    passwordMin: 'Parola en az 8 karakterden oluşmalıdır!',
    passwordMax: 'Parola en az 50 karakterden oluşmalıdır!',
    phone: 'Telefon Numarası 10 karakter olarak girilmeli',
    confirmPassword: 'Şifreler Eşleşmelidir',
  },
  message: {
    areYouSureDelete: 'Kayıdı Silmek istiyor musunuz?',
    deleteContent:
      'Kullanıcı kaydını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    deleteAddress:
      'Adresi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    successDelete: 'Başarıyla silindi',
    success: 'Başarılı!',
    successShipment: 'Başarılı ile gönderi oluşturuldu!',
    createSuccess: 'Cari başırıyla oluşturuldu!',
    deleteService:
      'Servisi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    deleteServiceType:
      'Servis tipini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    deleteShipmentPiece:
      'Parça bilgisi silme işleminden emin misiniz? Bu işlem geri alınamaz!',
    deleteProductOfPiece:
      'İç ürün silme işleminden emin misiniz? Bu işlem geri alınamaz!',
    deleteCurrency:
      'Para birimini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    deleteRole:
      'Rolü silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
  },
  text: {
    currentCreate: 'Cari Oluştur',
  },
};
